import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import LazyLoad from "react-lazyload"; 
import SwiperCore, { FreeMode, Navigation, Thumbs, Autoplay } from "swiper";
import * as apiUrl from "../../apiUrl";

SwiperCore.use([FreeMode, Navigation, Thumbs, Autoplay]);

function ConstructionPageImage({ slideImages, thumbImages }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const constructionSlides = slideImages ? JSON.parse(slideImages) : [];
  const constructionThumbs = thumbImages ? JSON.parse(thumbImages) : [];

  return (

    <div className="home-community-sec construction-new-sec">
      <Container fluid className="home-community-container">
        <Row>
          <Col md={12}>
            <div className="home-community-swiper construction-image-swiper">
              {/* Main Swiper for slide images */}
              <Swiper
                loop={false}
                slidesPerView={1}
                spaceBetween={0}
                autoplay={{ delay: 3000 }}
                speed={1000}
                slidesPerGroup={1}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                navigation={true}
                className="mySwiper2"
              >
                {constructionSlides.map((image, index) => (
                  <SwiperSlide key={index}>
                    <LazyLoad>
                      <img
                        src={`${apiUrl.apiUrl}/${image.construction_image}`}
                        className="img-fluid"
                        alt={`slide-image-${index}`}
                      />
                    </LazyLoad>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Thumbnail Swiper */}
              <Swiper
                onSwiper={setThumbsSwiper}
                loop={false}
                slidesPerGroup={1}
                autoplay={{ delay: 3000 }}
                speed={1000}
                spaceBetween={20}
                slidesPerView={7}

                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                breakpoints={{
                  240: { slidesPerView: 4, spaceBetween: 10 },
                  320: { slidesPerView: 4, spaceBetween: 10 },
                  420: { slidesPerView: 4, spaceBetween: 10 },
                  768: { slidesPerView: 4, spaceBetween: 10 },
                  1024: { slidesPerView: 6 },
                  1280: { slidesPerView: 7 },
                }}
                className="mySwiper"
              >
                {constructionThumbs.map((image, index) => (
                  <SwiperSlide key={index}>
                    <LazyLoad>
                      <img
                        src={`${apiUrl.apiUrl}/${image.construction_thumb}`}
                        className="img-fluid"
                        alt={`thumb-image-${index}`}
                      />
                    </LazyLoad>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ConstructionPageImage;
